import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation('home');
  const [expanded, setExpanded] = useState(false);
  const displayCategories = expanded ? categories : categories.slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-main">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-wider mb-2">
            {t('categories.all')}
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {t('categories.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('categories.description')}
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4 mb-6">
          {displayCategories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300 hover:scale-[1.02]"
            >
              <div className="aspect-[4/5] relative overflow-hidden">
                <img
                  src={cat.image}
                  alt={t(cat.i18nKey)}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="px-3 py-3 bg-background-50 text-center border-t border-background-200/70">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {t(cat.i18nKey)}
                </h3>
                <span className="inline-flex items-center gap-1 mt-1 text-xs text-foreground-400 group-hover:text-primary-600 transition-colors">
                  {t('articles.read_more')}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* Expand button */}
        {categories.length > 8 && (
          <div className="text-center">
            <button
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-200 text-sm font-medium text-foreground-700 hover:bg-background-200 transition-colors"
            >
              {expanded ? (
                <>
                  <i className="ri-arrow-up-s-line" />
                  Show Less
                </>
              ) : (
                <>
                  <i className="ri-arrow-down-s-line" />
                  Show All {categories.length} Categories
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}